import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <CommentsSection />
        <TopicsSection />
        <FeaturesSection />
        <IndexSection />
        <MediaSection />
        <AboutSection />
        <CardsSection />
        <ContactSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}